export const TIDS = {
  // Navbar
  navbar: 'navbar',
  navLogo: 'nav-logo',
  navServices: 'nav-link-services',
  navHowItWorks: 'nav-link-how',
  navMemberships: 'nav-link-memberships',
  navBook: 'nav-cta-book',
  langToggle: 'language-toggle',

  // Hero
  heroHeadline: 'hero-headline',
  heroCtaPrimary: 'hero-cta-book',
  heroCtaSecondary: 'hero-cta-plans',

  // Services
  servicesSection: 'services-section',
  serviceCard: (k) => `service-card-${k}`,

  // How it Works
  howSection: 'how-section',
  howStep: (i) => `how-step-${i}`,

  // Memberships
  membershipsSection: 'memberships-section',
  membershipCard: (id) => `membership-card-${id}`,
  membershipSelect: (id) => `membership-select-${id}`,

  // Booking
  bookingSection: 'booking-section',
  bookingForm: 'booking-form',
  fullName: 'booking-full-name',
  email: 'booking-email',
  phone: 'booking-phone',
  pickupAddress: 'booking-pickup-address',
  deliveryAddress: 'booking-delivery-address',
  dateTrigger: 'booking-date-trigger',
  dateCalendar: 'booking-date-calendar',
  timeSelect: 'booking-time-select',
  membershipSelectField: 'booking-membership-select',
  detergentSelect: 'booking-detergent-select',
  notes: 'booking-notes',
  submit: 'booking-submit',
  successDialog: 'booking-success-dialog',
  successClose: 'booking-success-close',

  // Footer
  footer: 'footer',
};
